import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofActionSuccessful, Select, Store } from "@ngxs/store";
import { delay, Observable, of, repeat, take } from "rxjs";
import { News } from "../../models/news.model";
import { NewsActions } from "../../states/news.actions";
import { NewsSelectors } from "../../states/news.selectors";

@UntilDestroy()
@Component({
    selector: "ntf-news-list",
    templateUrl: "news-list.component.html",
    styleUrls: ["news-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsListComponent implements OnInit {
    @Select(NewsSelectors.news)
    public news$: Observable<News[]>;

    constructor(private store: Store, private actions$: Actions) {}

    public ngOnInit() {
        this.store.dispatch(new NewsActions.GetAllNews());

        this.actions$.pipe(ofActionSuccessful(NewsActions.SetStatusForAll)).pipe(untilDestroyed(this), take(1))
            .subscribe(() => {
                this.store.dispatch(new NewsActions.GetAllNews());
            });

        of(null).pipe(delay(60 * 1000), repeat(), untilDestroyed(this)).subscribe(() => {
            this.store.dispatch(new NewsActions.GetAllNews());
        });
    }
}
